/** Why Expand all is disabled, on both the tree table's toolbar button and the nested table's header. */
export const NO_EXPANDABLE_ROWS_TOOLTIP = 'No expandable rows.';
